import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/virtual';

import tippy, { hideAll } from 'tippy.js';
import 'tippy.js/dist/svg-arrow.css';
import 'tippy.js/dist/tippy.css';

elabs.ArticleTwoColumn = class ArticleTwoColumn {
  constructor(articleTwoColumn) {
    this.view = articleTwoColumn;
    this.sectionId = this.view.dataset.sectionId;

    const swiperElement = this.view.querySelector('.el-article-two-column-section__swiper');

    this.swiperSlider = new Swiper(swiperElement, {
      slidesPerView: 'auto',
      speed: 600,
      spaceBetween: 10,
      breakpoints: {
        768: { slidesPerView: 2, spaceBetween: 24 },
      },
    });

    const isTouchDevice = 'ontouchstart' in document.documentElement;
    tippy('.el-article-two-column-section__slide-btn', {
      trigger: isTouchDevice ? 'click' : 'mouseenter focus',
      interactive: true,
    });
  }
};

elabs.onJavascriptReady(() => {
  document.querySelectorAll('.el-article-two-column-section').forEach((element) => {
    if (element) {
      void new elabs.ArticleTwoColumn(element);
    }
  });
});
